import { useForm } from 'react-hook-form'
import { ICategory } from 'safe'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import InputText from '../../components/Inputs/InputText'
import { v4 as uuidv4 } from 'uuid'
import { FaRandom } from 'react-icons/fa'
import Tooltip from '../../components/Display/Tooltip'

const CategoryForm: React.FC<CategoryFormProps> = ({
  defaultValues,
  onCancel,
  useType = 'create',
  onSubmit,
  // categories,
}) => {
  const form = useForm<any>({ defaultValues: { ...defaultValues } })

  // const checkExist = () =>
  //   categories.find((cat) => cat.code === form.getValues('code'))

  const onSubmitCategory = (values: ICategory) => {
    // if (checkExist() && useType === 'create') {
    //   form?.setError('code', {
    //     type: 'manual',
    //     message: 'El codigo ya está en uso',
    //   })
    //   return
    // } else {
      form?.clearErrors('code')
      onSubmit(values)
    // }
  }

  return (
    <div>
      <Form
        form={form}
        onSubmit={(values) => {
          onSubmitCategory({ ...values, id: defaultValues?.id })
        }}
        classes={`gap-x-6 gap-y-2`}
      >
        <h1 className="font-bold text-primary-900 dark:text-gray-400 mb-8 col-span-12">
          {useType === 'create' ? 'Añadir' : 'Editar'} Categoria
        </h1>

        <FormItem
          name="name"
          classes="col-span-7"
          rules={{ required: 'Es necesario el nombre' }}
        >
          <InputText small label="Nombre" maxLength={30} />
        </FormItem>

        <FormItem
          name="code"
          classes="col-span-4"
          rules={{ required: 'Es necesario el codigo' }}
        >
          <InputText small label="Código" maxLength={6} />
        </FormItem>

        <Tooltip
          // key={0}
          title="Crear Código Aleatorio"
          position="top"
          xOffset={0}
          yOffset={0}
          show={true}
          classes="col-span-1 flex items-end mb-2"
          innerStyle={{width: 150, right: -45}}
        >
        {/* <div onClick={() => {
            form.setValue('code', uuidv4().slice(0, 6).toUpperCase())
          }}> */}
          <Button icon={<FaRandom />} type="outline" onClick={() => {
            form.setValue('code', uuidv4().slice(0, 6).toUpperCase())
          }} />
          {/* <Button type="primary" onClick={() => {
            form.setValue('code', uuidv4().slice(0, 6).toUpperCase())
          }}>
            Generar
          </Button>{' '} */}
        {/* </div> */}
        </Tooltip>


        {/* <div className='col-start-7 col-span-6'>
          Generar Automaticamente
        </div> */}

        <FormItem
          name="description"
          classes="col-span-12"
          rules={{ required: 'Es necesario una descripcion' }}
        >
          <InputText small label="Descripción" maxLength={100} />
        </FormItem>

        <div className='h-px dark:bg-primaryGray-600 bg-primaryGray-700 col-span-12 my-5'></div>

        <div className="col-span-12 h-full flex flex-row">
          <div className="w-1/2 mr-5 pl-1">
            <Button
              onClick={() => {
                onCancel && onCancel()
              }}
              type="outline"
              classes="w-full"
            >
              Cancelar
            </Button>
          </div>
          <div className="w-1/2 pr-1">
            <Button type="primary" classes="w-full" htmlType="submit">
              {useType === 'create' ? 'Agregar' : 'Actualizar'}
            </Button>
          </div>
        </div>
      </Form>
    </div>
  )
}

export default CategoryForm

interface CategoryFormProps {
  defaultValues?: object | any
  onCancel?: Function
  useType: string
  onSubmit: (values: ICategory) => void
  // categories: any[]
}
